import { useEffect, useState } from "react"
import { getCloseReasons } from "../../../../../services/clientReport.service"

const useClientSprintCloseReasons = (closeType) => {
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)

    useEffect(() => {
        if (!closeType || closeType !== "TIMEOUT") return;
        setLoading(true)
        setError(null)

        getCloseReasons({ closeType: closeType.toUpperCase() })
            .then((res) => setData(res))
            .catch((err) => setError(err))
            .finally(() => setLoading(false))
    }, [closeType])

    return { data, loading, error }
}

export default useClientSprintCloseReasons